import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f05bd1d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white-50 rounded-4 py-3 px-4 mb-5 w-100" }
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = { class: "row w-100" }
const _hoisted_4 = { class: "col-lg-6 d-flex align-items-center mb-lg-0 mb-3" }
const _hoisted_5 = { class: "text-nowrap me-3 col-3 search-chat" }
const _hoisted_6 = { class: "search-container position-relative w-100" }
const _hoisted_7 = ["maxlength"]
const _hoisted_8 = { class: "col-lg-6 d-flex align-items-center" }
const _hoisted_9 = { class: "me-3 text-nowrap col-3 search-chat" }
const _hoisted_10 = { class: "search-container position-relative w-100" }
const _hoisted_11 = ["maxlength"]
const _hoisted_12 = { class: "d-flex justify-content-center mt-4 w-100" }
const _hoisted_13 = {
  key: 0,
  class: "px-lg-5 mx-lg-5"
}
const _hoisted_14 = { class: "d-flex mb-3" }
const _hoisted_15 = {
  key: 0,
  class: "me-4"
}
const _hoisted_16 = { class: "d-flex align-items-center" }
const _hoisted_17 = { class: "d-flex mb-3" }
const _hoisted_18 = {
  key: 0,
  class: "me-4"
}
const _hoisted_19 = { class: "d-flex align-items-center" }
const _hoisted_20 = {
  key: 1,
  class: "px-5 mx-5 text-center fw-bold"
}
const _hoisted_21 = { class: "d-flex mx-auto mt-4 justify-content-center" }

import { computed, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'

import Button from '@/components/button/index.vue'
import Pagination from '@/components/pagination/index.vue'
import SelectCustom from '@/components/select-custom/index.vue'
import ChartCard from '@/views/user/conversations/components/ChartCard.vue'

import { MAX_LENGTH_TITLE_SEARCH, MAX_LENGTH_USER_NAME_SEARCH } from '@/constants/number'
import { translate } from '@/languages/i18n'
import { COMMUNITY_CHAT_LIST_STORE } from '@/store/constants'
import TotalRecords from '@/components/total-records/index.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const route = useRoute()
const router = useRouter()

const total_pages = computed(() => store.getters[COMMUNITY_CHAT_LIST_STORE.GETTERS.CHAT_LIST_HISTORIES]?.total_pages)
const chatList = computed(() => store.getters[COMMUNITY_CHAT_LIST_STORE.GETTERS.CHAT_LIST_HISTORIES]?.chatList)
const total_records = computed(() => store.getters[COMMUNITY_CHAT_LIST_STORE.GETTERS.CHAT_LIST_HISTORIES]?.total_records)

const formData = ref<{ post_title: string; user_name: string }>({
  post_title: '',
  user_name: '',
})
const isFilter = ref<boolean>(false)

const getData = (params: any): void => {
  store.dispatch(COMMUNITY_CHAT_LIST_STORE.ACTIONS.SET_CHAT_LIST_HISTORIES, {
    id: route.params?.id,
    params,
  })
}

const onSearch = (): void => {
  isFilter.value = true
  getData({
    management_no: route.params?.managementNo,
    page: 1,
    page_of_number: route.query?.page_of_number || 30,
    post_title: formData.value.post_title,
    user_name: formData.value.user_name,
  })
}

const backToDetail = () => {
  router.push(`/community/communities/${route.params?.id}/${route.path.split('/').includes('alumnus') ? 'alumnus' : 'community-users'}/${route.params?.managementNo}/edit`)
}

watch([() => route.query, () => route.params], () => {
  if (route.path.split('/').includes('chat-list')) {
    getData({
      management_no: route.params?.managementNo,
      page: route.query?.page || 1,
      page_of_number: route.query?.page_of_number || 30,
      post_title: formData.value.post_title,
      user_name: formData.value.user_name,
    })
  }
})

const dataSelectRecordPerPage = ref([
  { value: '30', label: '30' },
  { value: '50', label: '50' },
  { value: '100', label: '100' },
])

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("form", {
        onSubmit: _withModifiers(onSearch, ["prevent"])
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(translate)('postTitleSearch')), 1),
            _createElementVNode("div", _hoisted_6, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                placeholder: "入力してください。",
                maxlength: _unref(MAX_LENGTH_TITLE_SEARCH),
                class: "form-control w-100",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.post_title) = $event))
              }, null, 8, _hoisted_7), [
                [
                  _vModelText,
                  formData.value.post_title,
                  void 0,
                  { trim: true }
                ]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(translate)('username')), 1),
            _createElementVNode("div", _hoisted_10, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                placeholder: "入力してください。",
                maxlength: _unref(MAX_LENGTH_USER_NAME_SEARCH),
                class: "form-control w-100",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.user_name) = $event))
              }, null, 8, _hoisted_11), [
                [
                  _vModelText,
                  formData.value.user_name,
                  void 0,
                  { trim: true }
                ]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(Button, {
            title: _unref(translate)('CI10search'),
            type: 'secondary',
            htmlType: 'submit'
          }, null, 8, ["title"])
        ])
      ], 40, _hoisted_2)
    ]),
    (_unref(chatList)?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createVNode(TotalRecords, { totalRecords: _unref(total_records) }, null, 8, ["totalRecords"]),
          _createElementVNode("div", _hoisted_14, [
            (_unref(total_pages))
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createVNode(Pagination, { totalPage: _unref(total_pages) }, null, 8, ["totalPage"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(SelectCustom, {
                options: dataSelectRecordPerPage.value,
                keyName: 'page_of_number'
              }, null, 8, ["options"])
            ])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(chatList), (room) => {
            return (_openBlock(), _createBlock(ChartCard, {
              data: room,
              key: room.id,
              isAdmin: true
            }, null, 8, ["data"]))
          }), 128)),
          _createElementVNode("div", _hoisted_17, [
            (_unref(total_pages))
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createVNode(Pagination, { totalPage: _unref(total_pages) }, null, 8, ["totalPage"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_19, [
              _createVNode(SelectCustom, {
                options: dataSelectRecordPerPage.value,
                keyName: 'page_of_number'
              }, null, 8, ["options"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!_unref(chatList)?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_unref(translate)('OE70searchNoData')), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_21, [
      _createVNode(Button, {
        title: _unref(translate)('back'),
        type: 'secondary',
        onClick: backToDetail
      }, null, 8, ["title"])
    ])
  ], 64))
}
}

})